import axios from "axios";
import session from "../lib/sessionStorage";
import { isEmpty } from "../lib/utils";

const BASE_URL = process.env.REACT_APP_API_URL_BASE;

/**
 * Returns a Axios Request Promise
 * method : get, post, put, patch, delete
 */
export default function request({ url, method = "get", data, config }) {
  let api_url = BASE_URL + url;

  let token = `Bearer ${session.get("token")}`;

  return axios({
    method: method,
    url: encodeURI(api_url),
    data: data,
    headers: {
      Pragma: "no-cache",
      Authorization: token,
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
    },
    // withCredentials: true,
    ...config,
  })
    .then((response) => {
      // 토큰 만료 체크
      if (
        response.data &&
        response.data.success === 0 &&
        response.data.message &&
        response.data.message.includes("Invalid Token")
      ) {
        console.log("토큰이 만료되었습니다. 로그인 페이지로 이동합니다.");
        // 세션 스토리지 클리어
        session.remove("token");
        session.remove("isLogin");
        session.remove("userIdx");
        session.remove("isAdmin");
        // 로그인 페이지로 리다이렉트
        window.location.href = "/login";
        return Promise.reject(new Error("Token expired"));
      }
      return response;
    })
    .catch((error) => {
      // throw error;
      // throw error.response.data;
      console.log(error);
      if (!isEmpty(error)) {
        // 토큰 만료 에러가 아닌 경우에만 에러 페이지로 이동
        if (error.message !== "Token expired") {
          window.location.href = "/error";
        }
      }
    });
}
